/**
 * @generated SignedSource<<029cb0947f7c33828aa3d44657e44679>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EmployeeRoleFocusScrollSubscription$variables = {
  widgetId: string;
};
export type EmployeeRoleFocusScrollSubscription$data = {
  readonly widgetFocusScrollChanged: string;
};
export type EmployeeRoleFocusScrollSubscription = {
  response: EmployeeRoleFocusScrollSubscription$data;
  variables: EmployeeRoleFocusScrollSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "widgetId",
        "variableName": "widgetId"
      }
    ],
    "kind": "ScalarField",
    "name": "widgetFocusScrollChanged",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeeRoleFocusScrollSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmployeeRoleFocusScrollSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "88f6f75f36a2c00ee5f39942221ca8ac",
    "id": null,
    "metadata": {},
    "name": "EmployeeRoleFocusScrollSubscription",
    "operationKind": "subscription",
    "text": "subscription EmployeeRoleFocusScrollSubscription(\n  $widgetId: ID!\n) {\n  widgetFocusScrollChanged(widgetId: $widgetId)\n}\n"
  }
};
})();

(node as any).hash = "016679b929683103416548d98d142b7b";

export default node;
